import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaHeart, FaArrowRight, FaStar } from 'react-icons/fa';
import '../../../assets/css/student/blogs/StoriesSection.css';

const StoriesPage = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const stories = [
    {
      id: 1,
      title: "From Struggle to Success: Fatima's Medical Dream",
      excerpt: "How a girl from a small village overcame poverty to become a doctor and now serves her community with pride.",
      image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80",
      impact: "Helped 500+ patients",
      location: "Lahore, Pakistan"
    },
    {
      id: 2,
      title: "The Teacher Who Never Gave Up: Usman's Story",
      excerpt: "A young man's journey from being unable to afford school fees to becoming an inspiring teacher for underprivileged children.",
      image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80",
      impact: "Teaching 200+ students",
      location: "Karachi, Pakistan"
    },
    {
      id: 3,
      title: "Engineering Hope: Ali's Transformation",
      excerpt: "From living in a one-room house to building tech solutions that help thousands, Ali's story inspires us all.",
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&q=80",
      impact: "Created 50+ jobs",
      location: "Islamabad, Pakistan"
    },
    {
      id: 4,
      title: "Breaking Boundaries: Ayesha's Business Success",
      excerpt: "How education empowered a young woman to start her own business and employ other women from her community.",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80",
      impact: "Employed 30+ women",
      location: "Multan, Pakistan"
    },
    {
      id: 5,
      title: "The Scientist's Journey: Hassan's Research",
      excerpt: "From struggling to afford textbooks to conducting groundbreaking research in renewable energy.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80",
      impact: "3 Published papers",
      location: "Faisalabad, Pakistan"
    },
    {
      id: 6,
      title: "Artist with a Purpose: Zainab's Creative Path",
      excerpt: "How art education transformed a shy girl into a celebrated artist who now teaches art to underprivileged children.",
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&q=80",
      impact: "Trained 100+ students",
      location: "Peshawar, Pakistan"
    }
  ];

  return (
    <div className="stories-page">
      {/* Header Section */}
      <div className="stories-header">
        <div className="stories-header-content">
          {/* <Link to="/" className="back-link">
            <FaArrowLeft /> Back to Home
          </Link> */}
          
          <div className="stories-header-icon">
            <FaHeart />
          </div>
          
          <h1 className="stories-main-title">Success Stories</h1>
          <p className="stories-main-subtitle">
            Real stories of real students whose lives have been transformed through
            education and the generous support of our donor community.
          </p>
        </div>
      </div>

      {/* Stories Grid */}
      <div className="stories-container">
        <div className="stories-grid">
          {stories.map((story) => (
            <article
              key={story.id}
              className={`story-card ${hoveredCard === story.id ? 'hovered' : ''}`}
              onMouseEnter={() => setHoveredCard(story.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              {/* Image Container */}
              <div className="story-image-container">
                <img 
                  src={story.image} 
                  alt={story.title}
                  className="story-image"
                  loading="lazy"
                />
                <div className="story-image-overlay">
                  <div className="story-badge">
                    <FaStar /> Featured Story
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="story-content">
                <div className="story-meta">
                  <span className="story-impact">{story.impact}</span>
                  <span className="story-location">{story.location}</span>
                </div>

                <h2 className="story-title">{story.title}</h2>
                <p className="story-excerpt">{story.excerpt}</p>

                <Link to={`/stories/${story.id}`} className="story-read-more">
                  Read Full Story <FaArrowRight className="arrow-icon" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StoriesPage;